import { Injectable, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { take } from 'rxjs';

/**
 * Custom TitleStrategy that integrates with Transloco for translated page titles.
 *
 * - Walks up the route tree to find the nearest title key (inheritance)
 * - Uses selectTranslate() to wait for translations to load
 * - Appends the brand suffix "| Webplanner | ASVZ"
 * - Silently falls back to "Webplanner | ASVZ" when no title is defined
 */
@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly transloco = inject(TranslocoService);
  private readonly destroyRef = inject(DestroyRef);

  private readonly brandSuffix = 'Webplanner | ASVZ';

  override updateTitle(routerState: RouterStateSnapshot): void {
    const titleKey = this.buildTitle(routerState);

    /**
     * According to issue #217 the title is static now but it might be extended 
     * in the future to support dynamic titles. 
     * For now, we set the title to the brand suffix.
     */
    this.title.setTitle(this.brandSuffix);

    // if (titleKey) {
    //   this.transloco
    //     .selectTranslate(titleKey)
    //     .pipe(take(1), takeUntilDestroyed(this.destroyRef))
    //     .subscribe((translatedTitle) => {
    //       // If translation returns the key itself, it means no translation exists
    //       const displayTitle = translatedTitle !== titleKey ? translatedTitle : titleKey;
    //       this.title.setTitle(`${displayTitle} | ${this.brandSuffix}`);
    //     });
    // } else {
    //   // Silent fallback to default title
    //   this.title.setTitle(this.brandSuffix);
    // }
  }
}
